var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.0298,
    cy: 16.0303,
    r: 9.52398,
    stroke: "#302F3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0279 25.0533C21.0117 25.0533 25.0519 21.0132 25.0519 16.0294C25.0519 11.0455 21.0117 7.00537 16.0279 7.00537C11.0441 7.00537 7.00391 11.0455 7.00391 16.0294C7.00391 21.0132 11.0441 25.0533 16.0279 25.0533ZM16.0289 22.7983C19.7667 22.7983 22.7969 19.7682 22.7969 16.0303C22.7969 12.2925 19.7667 9.26235 16.0289 9.26235C12.291 9.26235 9.26089 12.2925 9.26089 16.0303C9.26089 19.7682 12.291 22.7983 16.0289 22.7983Z",
    fill: "url(#paint0_linear_79_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6792 5.35355C15.4839 5.15829 15.4839 4.84171 15.6792 4.64645L18.8611 1.46447C19.0564 1.2692 19.373 1.2692 19.5682 1.46447C19.7635 1.65973 19.7635 1.97631 19.5682 2.17157L16.7398 5L19.5682 7.82843C19.7635 8.02369 19.7635 8.34027 19.5682 8.53553C19.373 8.7308 19.0564 8.7308 18.8611 8.53553L15.6792 5.35355ZM16.0327 26.4219C21.8101 26.4219 26.4937 21.7384 26.4937 15.9609H27.4937C27.4937 22.2906 22.3624 27.4219 16.0327 27.4219V26.4219ZM26.4937 15.9609C26.4937 10.1835 21.8101 5.5 16.0327 5.5V4.5C22.3624 4.5 27.4937 9.63124 27.4937 15.9609H26.4937Z",
    fill: "url(#paint1_linear_79_585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3145 26.5683C16.5098 26.7636 16.5098 27.0802 16.3145 27.2754L13.1325 30.4574C12.9373 30.6527 12.6207 30.6527 12.4254 30.4574C12.2301 30.2621 12.2301 29.9456 12.4254 29.7503L15.2538 26.9219L12.4254 24.0934C12.2301 23.8982 12.2301 23.5816 12.4254 23.3863C12.6207 23.1911 12.9373 23.1911 13.1325 23.3863L16.3145 26.5683ZM15.9609 5.49999C10.1835 5.49999 5.5 10.1835 5.5 15.9609L4.5 15.9609C4.5 9.63123 9.63124 4.49999 15.9609 4.49999L15.9609 5.49999ZM5.5 15.9609C5.5 21.7384 10.1835 26.4219 15.9609 26.4219L15.9609 27.4219C9.63124 27.4219 4.5 22.2906 4.5 15.9609L5.5 15.9609Z",
    fill: "url(#paint2_linear_79_585)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.8965,
    cy: 12.646,
    r: 3.38333,
    fill: "url(#paint3_linear_79_585)",
    fillOpacity: 0.5,
    stroke: "#AAECD8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1656,
    cy: 18.6602,
    r: 3.38333,
    fill: "url(#paint4_linear_79_585)",
    fillOpacity: 0.5,
    stroke: "#AAECD8",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_585",
    x1: 7.00391,
    y1: 7.00537,
    x2: 28.229,
    y2: 19.7705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_585",
    x1: 21.5132,
    y1: 6.09609,
    x2: 21.5132,
    y2: 26.9219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_585",
    x1: 10.4805,
    y1: 25.8258,
    x2: 10.4805,
    y2: 4.99999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_79_585",
    x1: 12.8965,
    y1: 9.82603,
    x2: 12.8965,
    y2: 15.7793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_79_585",
    x1: 20.1656,
    y1: 15.8402,
    x2: 20.1656,
    y2: 21.7935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swapIcon.7c14308b494791e74dac1714ad468f1f.svg";
export { ForwardRef as ReactComponent };